/* store.icon.svg.js */

module.exports = {
    icon: `<svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="foreground-gl" d="M23.2131 0.630859H1.55206V3.33849H23.2131V0.630859ZM24.5669 14.169V11.4614L23.2131 4.6923H1.55206L0.198242 11.4614V14.169H1.55206V22.2919H15.0902V14.169H20.5055V22.2919H23.2131V14.169H24.5669ZM12.3826 19.5843H4.25969V14.169H12.3826V19.5843Z" fill="#5D6F80"/>
  </svg>
  
    `
};
